import * as Service from 'types/service';
import { Box, Text } from '@tocktix/pantry';
import { DisplayTime } from '@tock/time';
import { formatDurationAsHMText } from 'utils/timeUtils';
import {
  isTimeRange,
  usePartyHeader,
} from 'components/service/party/partyRedesignCard/usePartyHeader';
import { servicePartyCardCssDefs } from 'components/service/party/partyCardRefresh/servicePartyCardCssDefs';
import { useTimeSinceSeated } from 'hooks/partyHooks';

interface Props {
  bottomLeft?: React.ReactNode;
  bottomRight?: React.ReactNode;
  party: Service.Party;
  onSelectParty(party: Service.Party): void;
  topRight?: React.ReactNode;
}

const ServicePartyCard: React.FC<Props> = ({
  bottomLeft,
  bottomRight,
  party,
  onSelectParty,
  topRight,
}) => {
  const { name, time } = usePartyHeader(party);
  const timeSinceSeated = useTimeSinceSeated(party);
  const topRightContent = topRight === undefined ? party.tableString : topRight;
  const bottomLeftContent =
    bottomLeft === undefined ? (
      time && !isTimeRange(time) ? (
        <DisplayTime timeValue={time} />
      ) : null
    ) : (
      bottomLeft
    );
  const bottomRightContent =
    bottomRight === undefined
      ? timeSinceSeated
        ? formatDurationAsHMText(timeSinceSeated)
        : null
      : bottomRight;

  return (
    <Box css={servicePartyCardCssDefs.card}>
      <Box css={servicePartyCardCssDefs.content}>
        <Box css={servicePartyCardCssDefs.row}>
          <button
            aria-label={`Open details for ${name}`}
            css={servicePartyCardCssDefs.partyNameButton}
            onClick={() => onSelectParty(party)}
            type="button"
          >
            <Text css={servicePartyCardCssDefs.partyName} variant="h4">
              {name}
            </Text>
          </button>
          <Text css={servicePartyCardCssDefs.trailingText} variant="h4">
            {topRightContent}
          </Text>
        </Box>

        <Box css={servicePartyCardCssDefs.row}>
          <Text color="fgSubtle" variant="body">
            {bottomLeftContent}
          </Text>
          <Text color="fgSubtle" css={servicePartyCardCssDefs.trailingText} variant="body">
            {bottomRightContent}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default ServicePartyCard;
